import React from 'react'
import { StyledWidget } from './Widget.style'

export const Widget = (props) => {
  const { widgetId } = props
  return (
    <StyledWidget data-stickee-widget-id={widgetId}/>
  )
}
